import { useNavigate } from "react-router-dom";
import { CaretLeft } from "@phosphor-icons/react";

export function PageHeader({ title, right, back = true }) {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-[#FDFBF7]/85 backdrop-blur-xl border-b border-stone-200/60 px-4 py-3 flex items-center gap-3">
      {back && (
        <button
          data-testid="header-back-btn"
          onClick={() => navigate(-1)}
          className="w-9 h-9 rounded-full bg-white border border-stone-200 flex items-center justify-center active:scale-95 transition-transform"
        >
          <CaretLeft size={18} weight="bold" className="text-stone-700" />
        </button>
      )}
      <h1 className="font-heading text-lg font-semibold text-stone-800 flex-1 truncate">{title}</h1>
      {right}
    </header>
  );
}
